import Logger from "../logger";
import domesticZipData from '../data/domestic-zips.json';

class KrempRules {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	static NAME = 'KrempRules';

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Check if it is after a specific time in a given zip code
	 */
	static isAfterCutOffTimeInZipCode(zip, dateStr, cutoffTimeStr) {
		// Logger.info(`${this.NAME} > isAfterCutOffTimeInZipCode`);

		const zipData = this.getDomesticZipData(zip);
		const dateParts = dateStr.split('-');

		if (zipData && dateParts.length === 3 && cutoffTimeStr.length === 4) {
			const timezone = zipData.timezone;

			// Get the current time in the timezone
			const time = new Date().toLocaleString('en-US', { timeZone: timezone });
			const currentTime = new Date(time);

			// Cast the cutoffTimeStr to a number
			const cutoffTime = new Date(time);
			cutoffTime.setFullYear(dateParts[0]);
			cutoffTime.setMonth(dateParts[1] - 1);
			cutoffTime.setDate(dateParts[2]);
			var cutoffHours = cutoffTimeStr.substring(0, 2);
			cutoffTime.setHours(cutoffHours);
			var cutoffMinutes = cutoffTimeStr.substring(cutoffTimeStr.length - 2);
			cutoffTime.setMinutes(cutoffMinutes);
			cutoffTime.setSeconds(0);

			// console.log(currentTime, cutoffTime);

			if (currentTime > cutoffTime) {
				return true;
			}

		}

		return false;
	}

	/**
	 * Get date object for a string, in the timezone of a given zip code
	 */
	static getDateObjectForZipCode(zip, dateStr) {
		// Logger.info(`${this.NAME} > getDateObjectForZipCode`);

		const zipData = this.getDomesticZipData(zip);

		const date = new Date(dateStr);
		if (isNaN(date)) {
			return 'Invalid date';
		}

		const year = date.getFullYear();
		const month = (date.getMonth() + 1).toString().padStart(2, '0');
		const day = date.getDate().toString().padStart(2, '0');

		const formattedDate = `${year}-${month}-${day}`;

		const dateParts = formattedDate.split('-');

		if (zipData && dateParts.length === 3) {
			const timezone = zipData.timezone;

			// Get the current time in the timezone
			const time = new Date().toLocaleString('en-US', { timeZone: timezone });
			const currentTime = new Date(time);
			currentTime.setFullYear(dateParts[0]);
			currentTime.setMonth(dateParts[1] - 1);
			currentTime.setDate(dateParts[2]);
			currentTime.setHours(0);
			currentTime.setMinutes(0);
			currentTime.setSeconds(0);

			return currentTime;
		}

		return null;
	}

	/**
	 * Get domestic zip data
	 */
	static getDomesticZipData(zip) {

		// Logger.info(`${this.NAME} > getDomesticZipData`);

		zip = parseInt(zip);

		// Check in domestic zip data JSON
		const data = domesticZipData.find(item => item.zipcode === zip);
		if (data) {
			return data;
		}

		return null;
	}

	/**
	 * Get timezone for zip code
	 */
	static getTimezoneForZipCode(zip) {
		Logger.info(`${this.NAME} > getTimezoneForZip > zip: ${zip}`);

		const data = this.getDomesticZipData(zip);
		if (data) {
			return data.timezone;
		}

		return null;
	}

	/**
		* Get flex shipping dates for zip code
		* @param {string} zip - Zip code
		* @returns {array} - Array of flex shipping dates
		*/
	static getFlexShippingDatesForZipCode(zip) {

		const holidaysArray = [];

		for (const holiday of window.pdpFlexShippingDates) {

			// Check if zip code is in the range of zip codes for this holiday
			if (holiday.zips.length > 0 && !holiday.zips.includes(parseInt(zip))) {
				console.log('Zip code not in range for holiday', holiday.holiday_name, zip, holiday.zips);
				continue;
			}

			// Check if zip code is in the excluded range of zip codes for this holiday
			if (holiday.excluded_zips.length > 0 && holiday.excluded_zips.includes(parseInt(zip))) {
				console.log('Zip code excluded from holiday', holiday.holiday_name, zip, holiday.excluded_zips);
				continue;
			}

			holidaysArray.push({
				"date": holiday.day_of_holiday,
				"holiday_name": holiday.holiday_name,
				"text": holiday.text
			});

			// Check how many days prior to holiday to highlight
			let flex_days_prior = Number(holiday.flex_days_prior);
			if (flex_days_prior > 0) {
				for (let i = 1; i <= flex_days_prior; i++) {
					const holiday_date = new Date(holiday.day_of_holiday);
					let prior_day = new Date(holiday_date);
					prior_day.setDate(holiday_date.getDate() + -i);
					holidaysArray.push({
						"date": prior_day.toISOString().slice(0, 10),
						"holiday_name": holiday.holiday_name,
						"text": holiday.text
					});
				}
			}

			// check how many days after the holiday to highlight
			let flex_days_post = Number(holiday.flex_days_post);
			if (flex_days_post > 0) {
				for (let i = 1; i <= flex_days_post; i++) {
					const holiday_date = new Date(holiday.day_of_holiday);
					let post_day = new Date(holiday_date);
					post_day.setDate(holiday_date.getDate() + i);
					holidaysArray.push({
						"date": post_day.toISOString().slice(0, 10),
						"holiday_name": holiday.holiday_name,
						"text": holiday.text
					});
				}
			}
		}

		return holidaysArray;
	}

	// static getFlexShippingRangeForDate(date) {
	// 	for (const holiday of window.pdpFlexShippingDates) {

	// 		let holidaysArray = [];

	// 		holidaysArray.push(holiday.day_of_holiday);

	// 		// Check how many days prior to holiday to highlight
	// 		let flex_days_prior = Number(holiday.flex_days_prior);
	// 		if (flex_days_prior > 0) {
	// 			for (let i = 1; i <= flex_days_prior; i++) {
	// 				const holiday_date = new Date(holiday.day_of_holiday);
	// 				let prior_day = new Date(holiday_date);
	// 				prior_day.setDate(holiday_date.getDate() + -i);
	// 				holidaysArray.push(prior_day.toISOString().slice(0, 10));
	// 			}
	// 		}

	// 		// check how many days after the holiday to highlight
	// 		let flex_days_post = Number(holiday.flex_days_post);
	// 		if (flex_days_post > 0) {
	// 			for (let i = 1; i <= flex_days_post; i++) {
	// 				const holiday_date = new Date(holiday.day_of_holiday);
	// 				let post_day = new Date(holiday_date);
	// 				post_day.setDate(holiday_date.getDate() + i);
	// 				holidaysArray.push(post_day.toISOString().slice(0, 10));
	// 			}
	// 		}

	// 		if (holidaysArray.includes(date)) {
	// 			return holiday;
	// 		}
	// 	}
	// }

	/**
	 * Check if zip code is domestic
	 * @param {*} zipCode
	 * @returns
	 */
	static zipCodeIsDomestic(zipCode) {
		Logger.info(`${this.NAME} > zipCodeIsDomestic > zipCode: ${zipCode}`);

		// Check if ZipCode is numeric, if not, then it is international
		if (isNaN(zipCode)) {
			return false;
		}

		// Check if ZipCode is NOT in the range of US Zip Codes. If not, then it is international
		// The range of zip codes in the United States is 00501 to 99950
		if (zipCode < 501 || zipCode > 99950) {
			return false;
		}

		// GUAM
		// Check if zipcode is in the range of Guam zip codes. If so, then it is international
		// All Guam zip codes are in the range 96910–96932
		if (zipCode >= 96910 && zipCode <= 96932) {
			return false;
		}

		// PUERTO RICO
		// Check if zipcode is in the range of Puerto Rico zip codes. If so, then it is international
		// Puerto Rico is allocated the ZIP codes 00600 to 00799 and 00900 to 00999
		if ((zipCode >= 600 && zipCode <= 799) || (zipCode >= 900 && zipCode <= 999)) {
			return false;
		}

		// AMERICAN SAMOA
		// Check if zipcode is in the range of American Samoa zip codes. If so, then it is international
		// American Samoa (postal abbreviation AS) uses zip code 96799
		if (zipCode === 96799) {
			return false;
		}

		// NORTHERN MARIANA ISLANDS
		// Check if zipcode is in the range of Northern Mariana Islands zip codes. If so, then it is international
		// Northern Mariana Islands postal code range goes from 96950 to 96952
		if (zipCode >= 96950 && zipCode <= 96952) {
			return false;
		}

		// US VIRGIN ISLANDS
		// Check if zipcode is in the range of US Virgin Islands zip codes. If so, then it is international
		// The 008xx codes are allocated to the nearby United States Virgin Islands
		if (zipCode >= 800 && zipCode <= 899) {
			return false;
		}

		// // APO, AE
		// // The zip code range for AE (Armed Forces Europe) is 09001–09910
		if (zipCode >= 9001 && zipCode <= 9910) {
			return false;
		}

		// APO, AP
		// APO AP: The zip code range for the Japan/Korea/Pacific Islands/Far East is 96201-96645
		if (zipCode >= 96200 && zipCode <= 96645) {
			return false;
		}

		// APO, AA
		// APO AA: The zip code range for the Armed Forces of the Americas is 34038-34078
		if (zipCode >= 34038 && zipCode <= 34078) {
			return false;
		}

		// FPO, AA
		const fpoAA = [
			34007,
			34009,
			34010,
			34058,
			34080,
			34081,
			34082,
			34083,
			34084,
			34085,
			34086,
			34087,
			34088,
			34089,
			34090,
			34091,
			34092,
			34093,
			34094,
			34095
		];
		if (fpoAA.includes(zipCode)) {
			return false;
		}



		// FPO, AP
		const fpoAP = [
			96212,
			96269,
			96306,
			96310,
			96311,
			96315,
			96321,
			96322,
			96346,
			96347,
			96349,
			96350,
			96351,
			96362,
			96370,
			96371,
			96372,
			96373,
			96374,
			96375,
			96377,
			96379,
			96380,
			96382,
			96384,
			96385,
			96387,
			96388,
			96389,
			96510,
			96511,
			96516,
			96517,
			96522,
			96531,
			96534,
			96537,
			96540,
			96542,
			96543,
			96578,
			96595,
			96598,
			96601,
			96602,
			96603,
			96604,
			96605,
			96606,
			96607,
			96608,
			96609,
			96610,
			96611,
			96612,
			96613,
			96615,
			96616,
			96617,
			96619,
			96620,
			96628,
			96629,
			96632,
			96643,
			96649,
			96650,
			96657,
			96660,
			96661,
			96662,
			96663,
			96664,
			96665,
			96666,
			96667,
			96668,
			96669,
			96670,
			96671,
			96672,
			96673,
			96674,
			96675,
			96677,
			96678,
			96679,
			96681,
			96682,
			96683,
			96686,
			96691,
			96692,
			96693,
			96694,
			96695,
			96696,
			96698
		];
		if (fpoAP.includes(zipCode)) {
			return false;
		}


		// FPO, AE
		const fpoAE = [
			'09204',
			'09216',
			'09241',
			'09266',
			'09363',
			'09410',
			'09424',
			'09501',
			'09502',
			'09503',
			'09504',
			'09505',
			'09506',
			'09507',
			'09508',
			'09509',
			'09510',
			'09511',
			'09512',
			'09513',
			'09514',
			'09516',
			'09517',
			'09520',
			'09522',
			'09523',
			'09524',
			'09532',
			'09534',
			'09543',
			'09550',
			'09554',
			'09556',
			'09564',
			'09565',
			'09566',
			'09567',
			'09568',
			'09569',
			'09570',
			'09573',
			'09574',
			'09575',
			'09576',
			'09577',
			'09578',
			'09579',
			'09581',
			'09582',
			'09583',
			'09586',
			'09587',
			'09588',
			'09589',
			'09590',
			'09591',
			'09592',
			'09593',
			'09594',
			'09595',
			'09596',
			'09599',
			'09607',
			'09608',
			'09609',
			'09617',
			'09618',
			'09620',
			'09621',
			'09622',
			'09623',
			'09625',
			'09626',
			'09627',
			'09631',
			'09636',
			'09645',
			'09647',
			'09648',
			'09649',
			'09712',
			'09729',
			'09733',
			'09761',
			'09805',
			'09834',
			'09837',
			'09838',
			'09859',
			'09865',
			'09902'
		];
		if (fpoAE.includes(zipCode)) {
			return false;
		}

		// If none of the above conditions are met, then the zip code is domestic
		return true;

	}

	// /**
	// * Evaluate zip code input and apply rules
	// * @param {string} zip - Zip code input
	// * @param {function} callback - Callback function
	// */
	// static evaluateZipCodeInput(zip, callback) {
	// 	console.log('Evaluating Zip Code:', zip);
	// 	const zipCode = zip;
	// 	let ruleApplied = false;
	// 	let ruleText = '';

	// 	// Create array to store applied zip code rules
	// 	const appliedZipRules = [];

	// 	// Loop through global zip code rules
	// 	for (const rule of globalZipCodeRules) {
	// 		console.log('Checking Rule:', rule.rule);

	// 		// Check if zip code is in rule
	// 		if (rule.zips.includes(zipCode)) {
	// 			ruleApplied = true;
	// 			ruleText = rule.text;
	// 			appliedZipRules.push(rule);
	// 		}
	// 	}

	// 	// Apply default shipping cutoff rule if no other rule is applied
	// 	if (!appliedZipRules.some(rule => rule.type === 'shipping cutoff')) {
	// 		console.log('Applying Default Shipping Cutoff Rule');
	// 		appliedZipRules.push(globalZipCodeRules.find(rule => rule.rule === "NonDirect NonLocal Cutoff 12:30pm PST"));
	// 	}

	// 	console.log('Applied Zip Rules:', appliedZipRules);

	// 	localStorage.removeItem('user_zipRules');
	// 	localStorage.setItem('user_zipRules', JSON.stringify({ 'rules': appliedZipRules }));

	// 	if (!ruleApplied) {
	// 		console.log('No Rule Applied');
	// 	}
	// 	if (callback) callback(KrempRules.evaluatePageZipcodeRules(pageRules));
	// }


	static getRulesForPageByZipCode(pageRules, zipCode) {
		console.log('Getting Rules for Page by Zip Code', zipCode);

		let rulesPayload = {
			calendar: {
				disabledDates: [],
			},
			rules: [],
		};

		console.log(window.globalZipCodeRules);

		// 1. Get all the zip code rules for this page, regardless of the zip code
		// that the customer is in
		const allRulesForProduct = window.globalZipCodeRules.filter(rule => pageRules.includes(rule.rule));
		console.log(`All Rules for Page`, allRulesForProduct);

		// 2. Filter the rules down to the ones that apply to the customer's zip code
		// If the zip code field is empty, it is assumed that the rule applies to all zip codes
		// If the zip code is in the excluded_zips array, the rule does not apply
		const rulesForCustomerZip = allRulesForProduct.filter(rule => (rule.zips.length == 0 || rule.zips.includes(parseInt(zipCode))) && !rule.excluded_zips.includes(parseInt(zipCode)));
		console.log(`Rules for Customer Zip`, rulesForCustomerZip);


		// 3. If there are rules that apply to the customer's zip code, add them to the payload
		if (rulesForCustomerZip.length > 0) {
			rulesPayload.rules = rulesForCustomerZip;
		}

		return rulesPayload;
	}

	// /**
	// 	* Evaluate page zip code rules
	// 	* @param {array} pageRules - Array of page zip code rules
	// 	*/
	// static evaluatePageZipcodeRules(pageRules) {
	// 	console.log('Evaluating Page Zip Code Rules');

	// 	console.log(pageRules);

	// 	let rulesPayload = {
	// 		calendar: {
	// 			disabledDates: [],
	// 		},
	// 		rules: [],
	// 	};

	// 	function removeDuplicates(arr) {
	// 		return arr.filter((item,
	// 			index) => arr.indexOf(item) === index);
	// 	}

	// 	// Get user zip rules from local storage
	// 	// Check if user zip rules exist and if page rules exist
	// 	// If not, stop
	// 	let storedUserZipRules = localStorage.getItem('user_zipRules');
	// 	if (!storedUserZipRules || storedUserZipRules.length === 0 || !pageRules) {
	// 		return;
	// 	}

	// 	// Parse user zip rules and remove duplicates from page rules
	// 	const userZipRules = JSON.parse(storedUserZipRules);
	// 	const pageZipRules = removeDuplicates(pageRules);
	// 	rulesPayload.rules = userZipRules.rules.filter(item => pageZipRules.includes(item.rule));

	// 	return rulesPayload;

	// 	console.log('User Zip Rules:', userZipRules.rules);
	// 	console.log('Page Zip Rules:', pageZipRules);
	// 	console.log('Matching Items:', matchingItems);

	// 	for (const item of matchingItems) {
	// 		console.log('*******************');
	// 		console.log(item);
	// 		console.log('Matched Rule:', item.rule, item.type);

	// 		// Apply rule based on type

	// 		// Check if rule is a warning
	// 		if (item.type === 'warning') {
	// 			console.log('WARNING');
	// 		}

	// 		// Check if product price is less than the rule's minimum price
	// 		// if (product_price < item.min_price) {
	// 		// 	new Notify({
	// 		// 		status: 'success',
	// 		// 		title: item.rule,
	// 		// 		text: item.text,
	// 		// 		effect: 'slide',
	// 		// 		speed: 300,
	// 		// 		customClass: '',
	// 		// 		customIcon: '<svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#144174" stroke-width="0.3"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.8902 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z" fill="#144174"></path> </g></svg>',
	// 		// 		showIcon: true,
	// 		// 		showCloseButton: true,
	// 		// 		autoclose: true,
	// 		// 		autotimeout: 3000,
	// 		// 		notificationsGap: null,
	// 		// 		notificationsPadding: null,
	// 		// 		type: 'filled',
	// 		// 		position: 'right bottom',
	// 		// 		customWrapper: '',
	// 		// 	});
	// 		// }


	// 		// Check if rule is a shipping cutoff
	// 		if (item.type === 'shipping cutoff') {

	// 			// PLP
	// 			if (pageTemplate == 'collection') {
	// 				let product_cards = Array.from(document.getElementsByClassName('card--product'));
	// 				product_cards.forEach(element => {
	// 					let product_card_info_container = element.getElementsByClassName('card__info-inner')[0];
	// 					const shipping_cutoff_message = document.createElement("div");
	// 					shipping_cutoff_message.textContent = item.text;
	// 					product_card_info_container.appendChild(shipping_cutoff_message);
	// 				});
	// 			}

	// 		}

	// 		if (item.type === 'checkout') {
	// 			// console.log("CHECKOUT");
	// 		}
	// 	}

	// 	setCalendarDays();
	// }

	/**
	 * Class static initialization block
	 */
	static {
		Logger.info(`${this.NAME} > init`);
	}
}

export default KrempRules;
